class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      // Initialize Algolia client
      this.initAlgolia();

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.input.addEventListener('keydown', (e) => this.handleKeydown(e));
      this.form.addEventListener('submit', (e) => e.preventDefault());
    }

    initAlgolia() {
      // Initialize Algolia search client
      // You need to set these in your theme settings or config
      const appId = window.algoliaConfig?.appId || '';
      const apiKey = window.algoliaConfig?.apiKey || '';
      const indexName = window.algoliaConfig?.indexName || 'products';

      if (!appId || !apiKey) {
        console.error('Algolia credentials not configured. Please set window.algoliaConfig');
        return;
      }

      this.algoliaClient = algoliasearch(appId, apiKey);
      this.algoliaIndex = this.algoliaClient.initIndex(indexName);
    }

    handleKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }


    updateProductCount() {
        let productCount = document.querySelectorAll(".predictive-search-products .card-product-main").length;
        document.querySelector(".listtext .cout").textContent = productCount;

        if(document.querySelector(".listtext .cout").textContent == '0'){
            document.querySelector('.suggestions-carousel .swiper-productsr__').style.display = 'block';
        }else{
            document.querySelector('.suggestions-carousel .swiper-productsr__').style.display = 'none';
        }
    }

    attachQueryIDToForms(queryID) {
      if (!queryID) return;

      // Attach queryID to all product forms in the search results
      const productForms = this.predictiveSearchResults.querySelectorAll('product-form');
      productForms.forEach(form => {
        // Store queryID as a data attribute and property
        form.algoliaQueryID = queryID;
        form.setAttribute('data-algolia-query-id', queryID);
      });
    }

    deduplicateProducts(hits) {
      // Use a Map to track unique products by product ID
      const uniqueProductsMap = new Map();

      hits.forEach(hit => {
        // Try to extract product ID from multiple sources
        let productId = null;

        // Method 1: Use handle as product identifier
        if (hit.handle) {
          productId = hit.handle;
        }
        // Method 2: Extract from _tags array (product:XXXXXX)
        else if (hit._tags && Array.isArray(hit._tags)) {
          const productTag = hit._tags.find(tag => tag.startsWith('product:'));
          if (productTag) {
            productId = productTag.replace('product:', '');
          }
        }
        // Method 3: Use objectID prefix (if structured as productId-variantId)
        else if (hit.objectID) {
          // Some Algolia configs use objectID like "12345-67890" where first part is product ID
          productId = hit.objectID.split('-')[0];
        }

        // Only add if we found a product ID and haven't seen it before
        if (productId && !uniqueProductsMap.has(productId)) {
          uniqueProductsMap.set(productId, hit);
        }
      });

      // Convert Map values back to array
      return Array.from(uniqueProductsMap.values());
    }

    getSearchResults(searchTerm) {
      if (!this.algoliaIndex) {
        console.error('Algolia not initialized');
        return;
      }

      // Search using Algolia
      this.algoliaIndex.search(searchTerm, {
        hitsPerPage: 10,
        clickAnalytics: true,  // Enable click analytics to get queryID
        filters: 'NOT product_type:Sample AND NOT product_type:"Gift Card" AND NOT product_type:Reward AND NOT tags:hide AND NOT tags:bogos-gift',
        attributesToRetrieve: [
          'objectID',
          'handle',
          'title',
          'product_type',
          'tags',
          '_tags',
          'variants',
          'images',
          'product_image',
          'available',
          'inventory_available',
          'inventory_policy',
          'variants_inventory_count',
          'variants_min_price',
          'meta'
        ]
      })
      .then(({ hits, queryID }) => {
        // Filter duplicate products by product ID (handle or product_id)
        const uniqueProducts = this.deduplicateProducts(hits);

        console.log(`Algolia returned ${hits.length} results, filtered to ${uniqueProducts.length} unique products`);

        // Debug: log first product to see available data structure
        if (uniqueProducts.length > 0) {
          console.log('Algolia product data sample:', uniqueProducts[0]);
          console.log('Algolia queryID:', queryID);

          // Debug price and metafields specifically
          const sampleProduct = uniqueProducts[0];
          console.log('Price debug:', {
            variantPrice: sampleProduct.variants?.[0]?.price,
            minPrice: sampleProduct.variants_min_price,
            available: sampleProduct.available,
            inventoryAvailable: sampleProduct.inventory_available,
            inventoryCount: sampleProduct.variants_inventory_count
          });
          console.log('Metafields debug:', {
            metafields: sampleProduct.meta,
            newProductTag: sampleProduct.meta?.custom?.new_product_tag,
            shortSubtitle: sampleProduct.meta?.custom?.short_subtitle
          });
          console.log('Tags debug:', {
            tags: sampleProduct.tags,
            _tags: sampleProduct._tags,
            variants: sampleProduct.variants
          });
        }

        // Store queryID for conversion tracking
        this.currentQueryID = queryID;

        // Generate HTML from Algolia results
        const resultsMarkup = this.generateResultsHTML(uniqueProducts, searchTerm);
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();

        // Attach queryID to all add-to-cart forms for conversion tracking
        this.attachQueryIDToForms(queryID);

        // Re-initialize components
        if (typeof initButtons === 'function') initButtons();
        if (typeof initGrid === 'function') initGrid();
        if (typeof setupButtons === 'function') {
          setupButtons(document.querySelectorAll('#predictive-search-results .wishlist-btn'));
        }

        this.updateProductCount();
      })
      .catch((error) => {
        console.error('Algolia search error:', error);
        this.close();
      });
    }

    generateResultsHTML(products, searchTerm) {
      if (!products || products.length === 0) {
        return `
          <div id="predictive-search-results">
            <button style="display: none;">
              Search for "${this.escapeHtml(searchTerm)}"
            </button>
          </div>
        `;
      }

      const productCards = products.map(product => this.generateProductCard(product)).join('');

      return `
        <div id="predictive-search-results">
          <div role="listbox" class="items frist_box swiper-productsr predictive-search-products" aria-labelledby="predictive-search-products">
            ${productCards}
          </div>
          <button style="display: none;">
            Search for "${this.escapeHtml(searchTerm)}"
          </button>
        </div>
      `;
    }

    getFirstVariantId(product) {
      // Try to get variant ID from multiple sources
      // Method 1: From variants array
      if (product.variants?.[0]?.id) {
        return product.variants[0].id;
      }

      // Method 2: From _tags array (Algolia structure)
      if (product._tags && Array.isArray(product._tags)) {
        const variantTag = product._tags.find(tag => tag.startsWith('variant:'));
        if (variantTag) {
          return variantTag.replace('variant:', '');
        }
      }

      return null;
    }

    generateProductCard(product) {
      const variant = product.variants?.[0] || {};
      const variantId = this.getFirstVariantId(product);
      const productUrl = `/products/${product.handle}`;
      const featuredImage = product.product_image;
      const secondaryImage = false; // NEEDS Fixing! product.images?.[1];

      // Check availability using inventory_available field from Algolia
      let isAvailable = product.inventory_available === true ||
                         product.inventory_available === 'true' ||
                         product.available === true;

      
      if (product.inventory_policy === 'continue') {
        isAvailable = true;
      }
      // Handle metafields - Algolia might structure them differently
      const newProductTag = product.meta?.custom?.new_product_tag ||
                           product['meta.custom.new_product_tag'] ||
                           product.new_product_tag;
      const shortSubtitle = product.meta?.custom?.short_subtitle ||
                           product['meta.custom.short_subtitle'] ||
                           product.short_subtitle;

      // Get button text from settings
      const addToCartText = window.themeStrings?.AddToCart || 'Add to Cart';
      const soldOutText = window.themeStrings?.SoldOut || 'Sold Out';
      const unavailableText = window.themeStrings?.Unavailable || 'Unavailable';

      let buttonText = addToCartText;
      let buttonDisabled = '';

      if (!variantId) {
        buttonText = unavailableText;
        buttonDisabled = 'disabled';
      } else if (!isAvailable) {
        buttonText = soldOutText;
        buttonDisabled = 'disabled';
      }

      return `
        <div class="card-product-main">
          <div class="inner-area">
            <div class="media-container">
              <div class="top-areas">
                <div class="badges">
                  ${newProductTag ? `<div class="new badge">${this.escapeHtml(newProductTag)}</div>` : ''}
                </div>
                ${this.generateWishlistButton(product)}
              </div>
              <div class="primary-image">
                ${this.generateImage(featuredImage, 500)}
              </div>
              ${secondaryImage ? `
                <div class="secondary-image">
                  ${this.generateImage(secondaryImage)}
                </div>
              ` : ''}

              <div class="addto_cart_box m-none">
                <product-form>
                  <form method="post" action="/cart/add" id="${product.objectID}" class="main-product-form" novalidate data-type="add-to-cart-form">
                    <input type="hidden" name="id" value="${variantId || ''}" class="product-variant-id" ${buttonDisabled}>
                    <div class="button-wrapper">
                      <button
                        id="ProductSubmitButton-${product.objectID}"
                        type="submit"
                        name="add"
                        class="button button-with-icon"
                        ${buttonDisabled}
                      >
                        <span>${buttonText}</span>
                      </button>
                    </div>
                  </form>
                </product-form>
              </div>
            </div>
            <div class="details">
              <a class="product-titile" href="${productUrl}">
                ${this.escapeHtml(product.title)}
              </a>
              <div class="price-wrapper">
                ${this.generatePrice(variant, product)}
              </div>

              ${shortSubtitle ? `
                <hr class="coustom_hr">
                <p class="custom_text">
                  ${this.escapeHtml(shortSubtitle)}
                </p>
              ` : ''}
            </div>

            <div class="addto_cart_box d-none">
              <product-form>
                <form method="post" action="/cart/add" id="${product.objectID}-mobile" class="main-product-form" novalidate data-type="add-to-cart-form">
                  <input type="hidden" name="id" value="${variantId || ''}" class="product-variant-id" ${buttonDisabled}>
                  <div class="button-wrapper">
                    <button
                      id="ProductSubmitButton-${product.objectID}-mobile"
                      type="submit"
                      name="add"
                      class="button button-with-icon"
                      ${buttonDisabled}
                    >
                      <span>${buttonText}</span>
                    </button>
                  </div>
                </form>
              </product-form>
            </div>
          </div>
        </div>
      `;
    }

    generateImage(image, width = null) {
      if (!image) return '';

      const imageUrl = typeof image === 'string' ? image : image.url || image.src;
      if (!imageUrl) return '';

      const alt = typeof image === 'object' ? (image.alt || '') : '';

      // Generate responsive image with srcset matching the Liquid snippet
      const widths = [300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000];
      const srcset = widths
        .map(w => {
          const responsiveUrl = this.getShopifyImageUrl(imageUrl, w);
          return `${responsiveUrl} ${w}w`;
        })
        .join(', ');

      const mainSrc = this.getShopifyImageUrl(imageUrl, width || 1920);

      return `<img
        src="${mainSrc}"
        srcset="${srcset}"
        sizes="100vw"
        alt="${this.escapeHtml(alt)}"
        loading="lazy"
        class="product_image">`;
    }

    getShopifyImageUrl(imageUrl, width) {
      if (!imageUrl || !imageUrl.includes('cdn.shopify.com')) {
        return imageUrl;
      }

      // Shopify CDN URL format: remove existing size and add new width
      return imageUrl
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master|\d+x\d*)\./gi, '.')
        .replace(/\.(jpg|jpeg|png|gif|webp)/i, `_${width}x.$1`);
    }

    generateWishlistButton(product) {
      // This should match your button-wishlist snippet structure
      // Adjust based on your actual wishlist implementation
      return `
        <button type="button" class="wishlist-btn" data-product-handle="${product.handle}">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="2" fill="none"/>
          </svg>
        </button>
      `;
    }

    generatePrice(variant, product) {
      // Try to get price from multiple sources
      let priceValue = variant?.price || product?.variants_min_price;

      if (!priceValue) return '';

      // Algolia stores prices in dollars, Shopify formatMoney expects cents
      const priceInCents = priceValue * 100;
      const compareAtPriceInCents = variant?.compare_at_price ? variant.compare_at_price * 100 : null;

      const price = this.formatMoney(priceInCents);
      const compareAtPrice = compareAtPriceInCents ? this.formatMoney(compareAtPriceInCents) : null;
      const hasVariants = product?.variants && product.variants.length > 1;
      const pricePrefix = hasVariants ? 'From ' : '';

      // Check if product is on sale
      const isOnSale = compareAtPrice && compareAtPriceInCents > priceInCents;

      if (isOnSale) {
        return `
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">
                  ${pricePrefix}${compareAtPrice}
                </span>
              </div>
              <div class="price__sale">
                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                <span class="price-item price-item--sale price-item--last">
                  ${pricePrefix}${price}
                </span>
              </div>
            </div>
          </div>
        `;
      }

      return `
        <div class="price">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">
                ${pricePrefix}${price}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>
                <s class="price-item price-item--regular"></s>
              </span>
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">
                ${pricePrefix}${price}
              </span>
            </div>
          </div>
        </div>
      `;
    }

    formatMoney(cents) {
      // Simple money formatting - adjust based on your theme's money format
      const amount = (cents / 100).toFixed(2);
      return window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}')
        : `$${amount}`;
    }

    escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

customElements.define('predictive-search', PredictiveSearch);
  



document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("searchInput");
    const inputValueDiv = document.querySelector(".inputvalue");
    const listText = document.querySelector(".listtext");
    searchInput.addEventListener("input", function () {
        inputValueDiv.textContent = searchInput.value;

        if (searchInput.value.trim() !== "") {
            listText.style.display = "block";
        } else {
            listText.style.display = "none";
        }
    });
});



